import { Directive, Input } from '@angular/core';
import { Validator, NG_VALIDATORS, FormControl, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[customMax]',
  providers: [{ provide: NG_VALIDATORS, useExisting: CustomMaxDirective, multi: true }]
})
export class CustomMaxDirective implements Validator {
  @Input() customMax: number;
  validate(c: AbstractControl): { [key: string]: any } {
    const value = c.value;
    return (parseFloat(value) > this.customMax) ? { 'customMax': true } : null;
  }
  constructor() { }
}
